import React, {useState, useEffect, useContext } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../css/zInternal_css.css';
import { ViewAttachement_ExpenseImageModal } from './Modal_ViewAttachement_ExpenseImage';

export function ExpenseDetailsModal_Projects(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewExpenseDetailData, setViewExpenseDetailData] = useState([]);


    let [expenseID, setExpenseID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);
    let [paymentType, setPaymentType] = useState(null);
    let [imageAttachement, setImageAttachement] = useState(null);
    let [viewAttachementModal, setViewAttachemntModal] = useState(false);



   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

        //alert('In Occupied Detailed Data');
        //alert(props.openModal);

        if(props.openModal == true)
        {

            /*
            let formData = new FormData();
            formData.append('Tracker', '74002A_De');
            formData.append('user', acctID);
            formData.append('xExpenseID', props.data.expenseID);
        
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002A_De_projects',
                    user: acctID,
                    xExpenseID: props.data.expenseID,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');


                    setViewExpenseDetailData((prevViewExpenseDetailData) => {
                        return prevViewExpenseDetailData.concat({
                            expenseID: cols[0],
                            supplierName: cols[1],
                            supplierPhoneNumber: cols[2],
                            expenseDescription: cols[3],
                            dateLogged: new Date(cols[4]).toISOString().substr(0, 10),
                            unitAmount: parseFloat(cols[5]).toFixed(2),
                            quantity: cols[6],
                            totalAmount: parseFloat(cols[7]).toFixed(2),
                            paymentType: cols[8],
                            attachment: cols[9],
                        })

                    });
        
                }    
            })
        }
    }, [props.openModal]);

    function viewExpenseAttachmentHandler(event) {

        //alert('In viewExpenseInvoiceHandler');
        //alert(event);
        //alert(event[0]);
        //alert(event[3]);
        //alert(event[4]);
        //alert(event[5]);

        setTotalAmount(event[3]);
        setPaymentType(event[4]);
        setImageAttachement(event[5]);

        setViewAttachemntModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function closeModalHandler() {

        setViewExpenseDetailData([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader className='grid_checkInHeader'>
            <IonGrid class='gridModalTopInfo'>
                    <IonRow>
                        <IonCol> Expense ID</IonCol>
                        <IonCol> Total Amount</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> {props.data.expenseID} </IonCol>
                        <IonCol> {props.data.totalAmount} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <div  style={{display: 'inline-block'}}>
            {viewExpenseDetailData.map((detailData) =>   {
            return (
            <IonGrid class='gridText'>
                <IonRow class='gridResultHeaders'>
                    <IonCol class='gridResultColumns'>Category</IonCol>
                    <IonCol class='gridResultColumns'>Value</IonCol>
                    <IonCol class='gridResultColumns'>Action</IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Supplier Name</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.supplierName}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Supplier Phone</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.supplierPhoneNumber}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Date Logged</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.dateLogged}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Unit Amount</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.unitAmount}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Quantity</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.quantity}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Description</IonCol>
                    <IonCol style={{fontSize: 'small'}}>{detailData.expenseDescription}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Payment Type</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.paymentType}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Attachment</IonCol>
                    <IonCol class='gridResultColumns'>{'Expense Attachment'}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <ViewAttachement_ExpenseImageModal openModal={ viewAttachementModal } closeModal={() => setViewAttachemntModal(false)} data={{
                                                paymentType: detailData.paymentType, 
                                                totalAmount: detailData.totalAmount, 
                                                fileLocation: detailData.attachment, 
                                                }}></ViewAttachement_ExpenseImageModal>

                        <IonButton className='appListButton' onClick={() => viewExpenseAttachmentHandler([true, detailData.unitAmount, detailData.quantity, detailData.totalAmount, detailData.paymentType, detailData.attachment])}> View </IonButton>

                    </IonCol>
                </IonRow>

                <IonButton onClick={closeModalHandler}> Close </IonButton>

            </IonGrid>
                    )
                }
            )}
        </div>
    </IonModal>) : null}
    </React.Fragment>
    )
}